import gql from 'graphql-tag';

import { Query, Mutation } from 'core/index';

import { CONTENT_FIELDS } from 'apps/content/gql';
import { USER_ERROR_FIELDS } from 'core/errors';

export const STORY_LIST_FIELDS = gql`
  ${CONTENT_FIELDS}
  fragment storyListFields on Story {
    id
    slug
    avatar {
      id
      path
      url
      completed
    }
    title
    readLength
    lastUpdated
    dateCreated
    content {
      ...contentFields
    }
    creatorProfile {
      id
      username
    }
    space {
      id
      spaceType
      content {
        id
        slug
      }
    }
    tags {
      id
      name
    }
    comments {
      totalCount
    }
  }
`;

export const STORY_FIELDS = gql`
  ${CONTENT_FIELDS}
  fragment storyFields on Story {
    id
    canUpdate
    canDelete
    slug
    avatar {
      id
      path
      url
      filename
      completed
    }
    title
    readLength
    lastUpdated
    dateCreated
    content {
      ...contentFields
    }
    creatorProfile {
      id
      username
      preferredName
      fullName
      bio
      avatar {
        id
        path
        url
      }
      content {
        ...contentFields
      }
    }
    space {
      id
      spaceType
      content {
        id
        slug
      }
    }
    inSpace {
      id
    }
    tags {
      id
      name
    }
    comments {
      totalCount
    }
  }
`;

export const STORY_CONNECTION_FIELDS = gql`
  ${STORY_LIST_FIELDS}
  fragment storyConnectionFields on StoryConnection {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      cursor
      node {
        ...storyListFields
        bodySnippet
      }
    }
  }
`;

export const STORY_MUTATION = gql`
  ${STORY_FIELDS}
  ${USER_ERROR_FIELDS}
  mutation Story($storyInput: StoryInput) {
    story(storyData: $storyInput) {
      story {
        ...storyFields
        bodySnippet
        body
      }
      userErrors {
        ...userErrorFields
      }
    }
  }
`;
export class StoryMutation extends Mutation {
  static conf = {
    GQL: STORY_MUTATION,
    inputName: 'storyInput',
    resultPath: 'story.story',
    errorPath: 'story.userErrors',
  };
}

export const STORY = gql`
  ${STORY_FIELDS}
  ${USER_ERROR_FIELDS}
  query Story($space: String, $slug: String) {
    story(space: $space, slug: $slug) {
      result {
        ...storyFields
        body
        bodySnippet
      }
      userErrors {
        ...userErrorFields
      }
    }
  }
`;
export class StoryQuery extends Query {
  static conf = {
    GQL: STORY,
    varNames: ['space', 'slug'],
    resultPath: 'story.result',
    errorPath: 'story.userErrors',
  };
}

export const STORIES = gql`
  ${STORY_CONNECTION_FIELDS}
  ${USER_ERROR_FIELDS}
  query HomeStories(
    $batchSize: Int
    $cursor: String
    $sortBy: String
    $filterBy: [[String!]]
  ) {
    stories(
      first: $batchSize
      after: $cursor
      sortBy: $sortBy
      filterBy: $filterBy
    ) {
      result {
        ...storyConnectionFields
      }
      userErrors {
        ...userErrorFields
      }
    }
  }
`;
export class StoriesQuery extends Query {
  static conf = {
    GQL: STORIES,
    varNames: ['batchSize', 'cursor', 'sortBy', 'filterBy'],
    resultPath: 'stories.result',
    errorPath: 'stories.userErrors',
  };
}

export const PROFILE_STORIES = gql`
  ${STORY_CONNECTION_FIELDS}
  ${USER_ERROR_FIELDS}
  query ProfileStories(
    $username: String!
    $cursor: String
    $batchSize: Int
    $sortBy: String
  ) {
    profile(username: $username) {
      result(username: $username) {
        id
        stories(first: $batchSize, after: $cursor, sortBy: $sortBy) {
          ...storyConnectionFields
        }
      }
      userErrors {
        ...userErrorFields
      }
    }
  }
`;
export class ProfileStoriesQuery extends Query {
  static conf = {
    GQL: PROFILE_STORIES,
    varNames: ['username', 'cursor', 'sortBy', 'batchSize'],
    resultPath: 'profile.result.stories',
    errorPath: 'profile.userErrors',
  };
}

export const INITIATIVE_STORIES = gql`
  ${STORY_CONNECTION_FIELDS}
  ${USER_ERROR_FIELDS}
  query InitiativeStories(
    $slug: String
    $cursor: String
    $batchSize: Int
    $sortBy: String
  ) {
    initiative(slug: $slug) {
      result {
        id
        stories(first: $batchSize, after: $cursor, sortBy: $sortBy) {
          ...storyConnectionFields
        }
      }
      userErrors {
        ...userErrorFields
      }
    }
  }
`;
export class InitiativeStoriesQuery extends Query {
  static conf = {
    GQL: INITIATIVE_STORIES,
    varNames: ['slug', 'cursor', 'sortBy', 'batchSize'],
    resultPath: 'initiative.result.stories',
    errorPath: 'initiative.userErrors',
  };
}
